/* global $:false */

import { ConfirmDialog } from '@cob/ui-genesis/helpers/cob.dialog.js'

// # Cob.Security
// Deals with user permissions.
var Security = function(core) {
    var _perms = {};

    var _request = function(url, type, callbacks, data){
        var _callbacks = callbacks || {},
            _data = data || {};

        $.ajax({
            url: url,
            type: type,
            contentType: _data.contentType,
            data: _data.content,
            // we must set `ignoreErrors` to true to avoid firing the global ajax error listener
            // that shows gritter alerts to the user and restarts the login process
            ignoreErrors: true,
            success: _callbacks.success,
            error: _callbacks.error,
            complete: _callbacks.complete
        });
    };

    var _login = function(credentials, callbacks){
        _request('security/auth', 'POST', callbacks,
            {
                content: $.toJSON(credentials),
                contentType: "application/json"
            });
    };

    var _loginAs = function(username, callbacks){
        var url = 'security/auth/impersonate/' + encodeURIComponent(username);

        _request(url, 'PUT', callbacks);
    };

    var _resetUser = function(callbacks){
        _request("security/auth/resetUser", 'PUT', callbacks);
    };

    var _logout = function(onSuccess) {
        var callbacks = {
            success: function() {
                if (onSuccess) onSuccess();

                core.publish("app:security:user-loggedout");
            }
        };

        _request('security/auth/logout', 'GET', callbacks);
    };

    var _completeCasLogin = function(originalSearchParams, onSuccess){
        const data = { }
        if(originalSearchParams.has('fragment')){
            data.fragment = originalSearchParams.get('fragment')
        }
        data.ticket = originalSearchParams.get('ticket')

        $.ajax({
            url: 'security/perms/global',
            data: data,
            type: 'GET',
            contentType: 'application/json',

            success: onSuccess,

            error: function(xhr) {
                const cobCasError = xhr.getResponseHeader("X-CoB-CAS-error")
                if(xhr.status === 401  && cobCasError === 'no-cob-user'){
                    window.location = '?noCas=true'

                } else {
                    // todo jone i18n e l10n
                    ConfirmDialog(core, {
                        message: 'Falhou a validação do Service Ticket CAS.<br/>Se o problema persistir, por favor contacte o Administrador.',
                        confirmBtnLabel: 'Tentar de novo!',
                        confirmBtnClass: 'btn-warning'
                    },{
                        requestConfirmed: () => window.location = '/',
                        requestCancelled: () => window.location =  '?noCas=true'
                    });
                }
            }
        });
    }

    var _loadPerms = function(callback){
            $.ajax({
                url: 'security/perms/global',
                type: 'GET',
                contentType: 'application/json',

                success: function(data) {
                    _perms = {};
                    data.perms.forEach(function(p) {
                        _perms[p.name] = true;
                    });
                },

                error: function(req) {
                    window.console.log("SECURITY:error " + req.status + " loading perms ");
                },

                complete: function() {
                    callback();
                }
            });
    }

    return {
        loadPerms: function(callback) {
            // as the index.html request is no longer made to the backend, we need to pass the cas ticket somewhere
            const url = new URL(window.location)
            const searchParams = url.searchParams;
            const casServiceTicketPresent = searchParams.has('ticket')
            const noCasPresent = searchParams.has('noCas')

            if(casServiceTicketPresent && !noCasPresent){
               _completeCasLogin(searchParams, () => {
                  if(searchParams.has('fragment')) window.location = '/' + searchParams.get('fragment')
                  else window.location = '/'
               })
            } else {
               _loadPerms(callback)
           }

        },

        hasPermission: function(perm) {
            return _perms[perm] === true;
        },

        login: _login,

        loginAs: _loginAs,

        resetUser: _resetUser,

        logout: _logout
    };
};

export default Security;
